<template>
  <div @click="headerClicked()" style="cursor:pointer">
    {{ label }}
    <i v-if="currentOrder == 'ascending'" class="fas fa-sort-up"></i>
    <i v-if="currentOrder == 'descending'" class="fas fa-sort-down"></i>
  </div>
</template>

<script>
export default {
  name: "sort-header",
  props: { label: null, prop: null, order: null },
  data() {
    return {
      currentOrder: null,
    };
  },
  methods: {
    mounted() {
      this.currentOrder = order;
    },
    headerClicked() {
      var self = this;
      var newOrder;

      if (!self.currentOrder) newOrder = "descending";
      else if (self.currentOrder == "ascending") newOrder = "descending";
      else if ((self.currentOrder = "descending")) newOrder = "ascending";

      self.currentOrder = newOrder;

      this.$emit("sorted", { prop: self.prop, order: newOrder });
    },
  },
};
</script>

<style></style>
